// import QuestionnaireDone from '../pages/make-questionnaire/components/QuestionnaireDone'

const phoneNumber = '0 2357 3590'

export enum statusUser {
    waiting = 'waiting', // รอการตรวจสอบ
    active = 'active', // ใช้งานได้
    disable = 'disable', //ระงับการใช้งาน
    reject = 'reject', //ปฏิเสธ
    expired = 'expired', // หมดอายุ
    unauthorized = 'unauthorized', // ไม่พบ  user
    duplicate = 'duplicate',
    invalid_community = 'invalid_community',
}

export const userStatusMessage = {
    waiting: `อยู่ระหว่างรอการอนุมัติ หากไม่ได้รับการอนุมัติภายใน 3-5 วันทำการ กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`, // รอการตรวจสอบ
    // active = 'active', // ใช้งานได้
    disable: `ไม่อนุญาตให้ใช้งาน กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`, //ระงับการใช้งาน
    reject: `ไม่อนุญาตให้ใช้งาน กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`, //ปฏิเสธ
    expired: `ไม่อนุญาตให้ใช้งาน กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`, // หมดอายุ
    unauthorized: 'ไม่พบเบอร์โทรศัพท์นี้ในระบบ', // ไม่พบ  user
    duplicate: `เบอร์โทรศัพท์นี้มีในระบบแล้ว กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`,
    invalid_community: `ไม่อนุญาตให้ใช้งาน กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`, // สถานะ ชุมชน ไม่เท่ากับ 1 (ผ่านการตรวจสอบ)
}

export const messageDialog = {
    error: `ระบบเกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`,
    invalid_status_community: `แบบประเมินของท่านไม่สามารถทำการบันทึกได้ โปรดกรุณาติดต่อเจ้าหน้าที่ ${phoneNumber}`,
}

export enum Roles {
    user = 'USER',
    admin = 'ADMIN',
}

export enum AccommodationType {
    otherType = 99,
}

export enum QuestStatus {
    editDraft = -2,
    draft = -1,
    wait = 0,
    done = 1,
    request = 2,
    approve = 3,
    reject = 4,
}

export enum QuestionnaireMode {
    todo = 1,
    draft = 2,
    edit = 3,
    view = 4,
}

export const ColorFont = {
    disable: '#7a7a7a',
    enable: '#000000',
}
